"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./data/types");
// todo make this more generic, it is really resource centric
var Ratios = /** @class */ (function () {
    function Ratios() {
        // @ts-ignore
        this[_a] = 0;
        // @ts-ignore
        this[_b] = 0;
        // @ts-ignore
        this[_c] = 0;
        // @ts-ignore
        this[_d] = 0;
    }
    Ratios.prototype.getHighest = function () {
        var e_1, _e;
        var sortable = [];
        try {
            for (var _f = __values(Object.getOwnPropertySymbols(this)), _g = _f.next(); !_g.done; _g = _f.next()) {
                var resource = _g.value;
                sortable.push([
                    resource,
                    this[resource]
                ]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_e = _f.return)) _e.call(_f);
            }
            finally { if (e_1) throw e_1.error; }
        }
        sortable.sort(function (a, b) {
            return a[1] - b[1];
        });
        var highest = sortable[sortable.length - 1][0];
        if (this[highest] === 0) {
            return types_1.Unknown;
        }
        return highest;
    };
    return Ratios;
}());
exports.default = Ratios;
_a = types_1.ResourceTypes.Wood, _b = types_1.ResourceTypes.Metal, _c = types_1.ResourceTypes.Cloth, _d = types_1.ResourceTypes.Diamond;
